import React from 'react';
import { Link } from 'react-router-dom';
import { formatSalary, timeAgo, MODALITY_LABELS, TYPE_LABELS } from '../../services/api';
import styles from './JobCard.module.css';

export default function JobCard({ job, saved, onSave, compact = false }) {
  const skills = typeof job.skills_required === 'string'
    ? JSON.parse(job.skills_required || '[]')
    : (job.skills_required || []);

  return (
    <div className={`${styles.card} ${job.is_featured ? styles.featured : ''} ${compact ? styles.compact : ''} card card-hover`}>
      {job.is_featured && <div className={styles.featuredTag}>⭐ Destacado</div>}
      {job.is_urgent && <div className={styles.urgentTag}>🔥 Urgente</div>}

      <Link to={`/jobs/${job.id}`} className={styles.mainLink}>
        <div className={styles.top}>
          <div className={styles.logo}>
            {job.logo_url
              ? <img src={job.logo_url} alt={job.company_name} />
              : <span>{(job.company_name||'?')[0]}</span>}
          </div>
          <div className={styles.info}>
            <h3>{job.title}</h3>
            <p className={styles.company}>
              {job.company_name}
              {job.company_verified && <span className={styles.verified} title="Empresa verificada">✓</span>}
              <span className={styles.dot}>·</span>
              {job.city}{job.province && job.province !== job.city ? `, ${job.province}` : ''}
            </p>
          </div>
        </div>

        <div className={styles.badges}>
          <span className={`badge ${job.modality === 'remote' ? 'badge-green' : job.modality === 'hybrid' ? 'badge-amber' : 'badge-blue'}`}>
            {MODALITY_LABELS[job.modality]}
          </span>
          <span className="badge badge-gray">{TYPE_LABELS[job.job_type]}</span>
          {job.is_demo && <span className="badge badge-amber">Demostración</span>}
          {job.category_name && <span className="badge badge-purple">{job.category_name}</span>}
        </div>

        {!compact && skills.length > 0 && (
          <div className={styles.skills}>
            {skills.slice(0,4).map((s,i) => <span key={i} className="tag">{s}</span>)}
            {skills.length > 4 && <span className="tag">+{skills.length-4}</span>}
          </div>
        )}

        <div className={styles.footer}>
          <span className={styles.salary}>
            {formatSalary(job.salary_min, job.salary_max, job.salary_currency, job.salary_visible, job.salary_period)}
          </span>
          <span className={styles.time}>{timeAgo(job.published_at)}</span>
        </div>
      </Link>

      {onSave && (
        <button className={`${styles.saveBtn} ${saved ? styles.saved : ''}`} onClick={(e)=>{e.preventDefault();onSave(job.id,saved);}} title={saved?'Quitar de guardados':'Guardar empleo'}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill={saved?'currentColor':'none'} stroke="currentColor" strokeWidth="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/>
          </svg>
        </button>
      )}
    </div>
  );
}
